import { createAccessLevel } from 'shared/domain/issue/mapping/accessLevel/model/createAccessLevel';
import { LabelledUser } from 'shared/domain/user/mapping/toView';
import type { UserAccessRecord } from 'shared/domain/issue/mapping/accessLevel/toOnView/types';
import type { AccessManagementRow, UserRoleObject } from 'shared/domain/issue/access/accessManagementRow';
import { userRoleLabelKey, translationKeyToString } from 'intl';
import { UserRole } from 'shared/types/userRole';
import { getAccessLevelOnDropdownView } from 'shared/domain/issue/mapping/accessLevel/toOnView/getAccessLevelOnDropdownView';
import { UserAccess } from 'shared/domain/issue/mapping/accessLevel/toOnView/types';
import {
  SubmitterOnAccessChangeView,
  TargetUserOnAccessChangeView,
} from 'shared/domain/user/types/view';

function roleToObject(userRole: UserRole): UserRoleObject {
  return {
    value: userRole,
    label: translationKeyToString(userRoleLabelKey(userRole)),
  };
}

export function usersToRows(
  users: TargetUserOnAccessChangeView[],
  userAccesses: UserAccess[],
  submitter: SubmitterOnAccessChangeView,
  siteId: string,
  processId: string
): AccessManagementRow[] {
  return users.map((user) => {
    return {
      name: user.label || user.email,
      role: roleToObject(user.role),
      _id: user._id,
      accessLevel: getAccessLevelOnDropdownView({
        issueUserAccesses: userAccesses,
        submitter,
        targetUser: user,
        siteId: siteId,
        processId: processId,
      }),
      email: user.email,
    };
  });
}
